export default {
  nav: {
    solutions: 'Solusi',
    cases: 'Studi Kasus',
    kol: 'Kemitraan KOL',
    contact: 'Hubungi Kami',
    login: 'Login Perusahaan'
  },
  hero: {
    badge: 'Komunikasi Real-Time Bertenaga AI',
    title: 'Komunikasi Real-Time Ultimate untuk Perusahaan Game Global',
    subtitle: 'Integrasi mendalam algoritma AI dan WebRTC, menyediakan solusi audio dan video ultra-low latency dan high-definition untuk pengembang game, mendukung interaksi lintas platform, terjemahan suara real-time, dan optimasi video cerdas',
    cta: 'Mulai Uji Coba Gratis',
    learn: 'Pelajari Lebih Lanjut',
    latency: 'Latensi Ultra-Rendah',
    nodes: 'Node Global',
    uptime: 'Waktu Aktif'
  },
  features: {
    title: 'Keunggulan Teknologi Inti',
    subtitle: 'Integrasi mendalam AI dan WebRTC untuk pengalaman komunikasi game yang sempurna',
    ai: {
      title: 'Optimasi Cerdas AI',
      desc: 'Pengurangan noise cerdas, pembatalan echo, dan peningkatan video untuk komunikasi yang jernih'
    },
    translate: {
      title: 'Terjemahan Real-Time',
      desc: 'Mendukung terjemahan real-time multi-bahasa, menghancurkan hambatan bahasa dan menghubungkan pemain global'
    },
    global: {
      title: 'Cakupan Node Global',
      desc: '200+ node global dengan routing cerdas untuk latensi terendah dan kualitas koneksi terbaik'
    },
    security: {
      title: 'Keamanan Tingkat Enterprise',
      desc: 'Enkripsi end-to-end, data aman dan andal, sesuai dengan standar privasi internasional'
    }
  },
  solutions: {
    title: 'Solusi',
    subtitle: 'Solusi komunikasi audio dan video profesional untuk berbagai skenario game',
    streaming: {
      title: 'Solusi Streaming Game',
      desc: 'Menyediakan teknologi streaming ultra-HD dan low-latency untuk streamer game, mendukung jutaan penonton bersamaan dengan interaksi real-time tanpa lag. Filter kecantikan bertenaga AI dan efek membuat streaming lebih menarik.',
      f1: 'Streaming 4K ultra-HD dengan latensi 25ms',
      f2: 'Filter kecantikan AI dan efek real-time',
      f3: 'Mendukung jutaan penonton bersamaan'
    },
    voice: {
      title: 'Solusi Suara Tim',
      desc: 'Komunikasi suara tim profesional untuk game kompetitif seperti MOBA dan Battle Royale, mendukung positioning audio spasial untuk lokasi rekan tim yang presisi. Pengurangan noise AI memastikan komunikasi yang jelas.',
      f1: 'Audio spasial 3D untuk positioning presisi',
      f2: 'Pengurangan noise AI menghilangkan noise latar belakang',
      f3: 'Mendukung 100 pengguna suara bersamaan'
    },
    social: {
      title: 'Solusi Interaksi Sosial',
      desc: 'Panggilan video multi-orang, hadiah virtual, dan interaksi real-time untuk game sosial. Mendukung terjemahan suara real-time untuk komunikasi mulus antara pemain dari berbagai negara.',
      f1: 'Panggilan video multi-orang, hingga 16 pengguna',
      f2: 'Terjemahan real-time, 50+ bahasa',
      f3: 'Hadiah virtual dan efek interaktif'
    },
    acceleration: {
      title: 'Solusi Akselerasi Game',
      desc: 'Berdasarkan node terdistribusi global dan algoritma routing cerdas, menyediakan layanan akselerasi jaringan untuk game, secara efektif mengurangi latensi dan packet loss. Mendukung optimasi protokol game multi untuk memastikan pengalaman gaming yang lancar.',
      f1: 'Routing cerdas, kurangi latensi hingga 60%+',
      f2: 'Optimasi multi-protokol, akselerasi UDP/TCP',
      f3: '200+ node global, akses terdekat'
    }
  },
  cases: {
    title: 'Kisah Sukses',
    subtitle: 'Menyediakan layanan komunikasi audio dan video profesional untuk ratusan perusahaan game di seluruh dunia',
    moba: {
      title: 'Game Kompetitif MOBA',
      desc: 'Menyediakan layanan streaming turnamen global dan suara tim untuk game MOBA terkenal, mendukung 500K+ pengguna bersamaan dengan latensi 18ms, memastikan acara esports yang lancar.',
      s1: 'Pengguna Bersamaan',
      s2: 'Latensi Rata-rata',
      s3: 'Waktu Aktif'
    },
    battle: {
      title: 'Game Battle Royale',
      desc: 'Menyediakan komunikasi suara ruangan 100 pemain untuk game battle royale, audio spasial 3D membantu pemain menentukan lokasi musuh dengan presisi, pengurangan noise AI memastikan komunikasi yang jelas, meningkatkan pengalaman game kompetitif.',
      s1: 'Kapasitas Ruangan',
      s2: 'Latensi Suara',
      s3: 'Kepuasan Pengguna'
    },
    casual: {
      title: 'Game Kasual Sosial',
      desc: 'Menyediakan panggilan video dan layanan streaming untuk platform game sosial, dengan lebih dari 1 juta pengguna aktif harian, mendukung terjemahan suara real-time, menghubungkan pemain global untuk pengalaman sosial internasional.',
      s1: 'Pengguna Aktif Harian',
      s2: 'Streaming Harian',
      s3: 'Tingkat Retensi'
    }
  },
  kol: {
    title: 'Program Kemitraan KOL',
    subtitle: 'Mengundang streamer game dan pembuat konten untuk bergabung dengan program kemitraan CM-Tong',
    b1: {
      title: 'Dukungan Khusus',
      desc: 'Tim dukungan teknis khusus dengan akses prioritas ke fitur terbaru'
    },
    b2: {
      title: 'Bagi Hasil',
      desc: 'Bagi hasil kemitraan, manfaat dari pertumbuhan platform'
    },
    b3: {
      title: 'Eksposur Merek',
      desc: 'Promosi saluran resmi untuk meningkatkan pengaruh merek pribadi'
    },
    b4: {
      title: 'Manfaat Prioritas',
      desc: 'Partisipasi prioritas dalam acara platform untuk lebih banyak eksposur'
    },
    cta: 'Ajukan Kemitraan'
  },
  contact: {
    title: 'Hubungi Kami',
    subtitle: 'Isi kebutuhan Anda dan kami akan menghubungi Anda dalam 24 jam',
    name: 'Nama',
    email: 'Email',
    company: 'Nama Perusahaan',
    message: 'Pesan',
    submit: 'Kirim',
    submitting: 'Mengirim...',
    success: 'Berhasil dikirim! Kami akan menghubungi Anda segera'
  },
  login: {
    title: 'Login Perusahaan',
    subtitle: 'Login ke akun perusahaan Anda untuk mulai menggunakan platform CM-Tong',
    email: 'Email Perusahaan',
    emailPlaceholder: 'Masukkan email perusahaan Anda',
    password: 'Kata Sandi',
    passwordPlaceholder: 'Masukkan kata sandi Anda',
    remember: 'Ingat saya',
    forgot: 'Lupa kata sandi?',
    submit: 'Login',
    noAccount: 'Belum punya akun?',
    signup: 'Daftar sekarang',
    back: 'Kembali ke Beranda'
  },
  footer: {
    desc: 'CM-Tong adalah platform audio dan video AI+WebRTC profesional, menyediakan solusi komunikasi real-time yang efisien dan low-latency untuk perusahaan game global.',
    product: 'Produk',
    company: 'Perusahaan',
    rights: 'Hak cipta dilindungi'
  }
};
